var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.events.length
    ? _c("div", { staticClass: "home-upcoming-events" }, [
        _vm._m(0),
        _vm._v(" "),
        _c("div", { staticClass: "upcoming-events-block" }, [
          _c(
            "div",
            { staticClass: "upcoming-events-image" },
            _vm._l(_vm.events, function(event, eid) {
              return event
                ? _c("img", {
                    key: "eid-" + eid,
                    class: { active: event == _vm.activeEvent },
                    attrs: { src: _vm.getUpload(event), alt: event.name }
                  })
                : _vm._e()
            }),
            0
          ),
          _vm._v(" "),
          _c("div", { staticClass: "upcoming-events-content" }, [
            _c(
              "div",
              { staticClass: "upcoming-events-list" },
              _vm._l(_vm.events, function(event, eid) {
                return _c(
                  "a",
                  {
                    key: "eidx-" + eid,
                    staticClass: "upcoming-event-item",
                    class: { active: event == _vm.activeEvent },
                    attrs: { href: "#/event/" + event.url_title },
                    on: {
                      mouseenter: function($event) {
                        return _vm.setActiveEvent(event)
                      }
                    }
                  },
                  [
                    _c("div", { staticClass: "event-hover" }, [
                      _c("div", { staticClass: "event-location" }, [
                        _c("h4", {
                          domProps: { innerHTML: _vm._s(event.venue_name) }
                        }),
                        _vm._v(" "),
                        _c("h5", [
                          _vm._v(
                            _vm._s(event.venue.city) +
                              ", " +
                              _vm._s(event.venue.state)
                          )
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "upcoming-dates" }, [
                      _c("span", [
                        _c("strong", [
                          _vm._v(
                            _vm._s(
                              _vm.printDate(
                                event.dates[0].date,
                                "yyyy-MM-dd",
                                "MMMM"
                              )
                            )
                          )
                        ]),
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.printDate(event.end.date, "yyyy-MM-dd", "dd")
                            )
                        )
                      ]),
                      _vm._v(" "),
                      event.dates.length > 1
                        ? _c("span", [
                            _c("span", { staticClass: "to" }, [_vm._v(" to ")]),
                            _vm._v(" "),
                            _vm.printDate(
                              event.dates[0].date,
                              "yyyy-MM-dd",
                              "MMMM"
                            ) !==
                            _vm.printDate(event.end.date, "yyyy-MM-dd", "MMMM")
                              ? _c("span", [
                                  _c("strong", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.printDate(
                                          event.end.date,
                                          "yyyy-MM-dd",
                                          "MMMM"
                                        )
                                      )
                                    )
                                  ])
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _c("span", [
                              _vm._v(
                                _vm._s(
                                  _vm.printDate(
                                    event.end.date,
                                    "yyyy-MM-dd",
                                    "dd"
                                  )
                                )
                              )
                            ])
                          ])
                        : _vm._e()
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "event-content" }, [
                      _c("h3", { domProps: { innerHTML: _vm._s(event.name) } })
                    ])
                  ]
                )
              }),
              0
            ),
            _vm._v(" "),
            _c("a", { staticClass: "view-all", attrs: { href: "/events" } }, [
              _vm._v("SEE ALL EVENTS")
            ])
          ])
        ])
      ])
    : _vm._e()
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "home-section-header" }, [
      _c("h3", [_vm._v("events")])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// /Users/nick/Desktop/Projects/kinston/wp-content/themes/kinston/node_modules/vue-loader/lib/loaders/templateLoader.js?{}!/Users/nick/Desktop/Projects/kinston/wp-content/themes/kinston/node_modules/vue-loader/lib?{}!/Users/nick/Desktop/Projects/kinston/wp-content/themes/kinston/node_modules/vue-svg-inline-loader/dist/index.min.js?{}!./scripts/components/UpcomingEvents.vue?vue&type=template&id=5dba101a&
// module id = 364
// module chunks = 0